import Blue from '~/core'

new Blue({
  name: 'selectbox',
  selector: '.social__dropdown__header',
  setup(selectbox) {
    const headerBtn = document.querySelector('.social__dropdown__header')
    const menuBox = document.querySelector('.social__dropdown__options')
    const outClick = document.querySelector(':not(.social__dropdown__options)')

    this.$addEvents(headerBtn, 'click.stop', (e) => {
      menuBox.style.display = 'block'
    })
    this.$addEvents(outClick, 'click.stop', () => {
      menuBox.style.display = 'none'
    })
  },
})
